import { render } from "./Lottery_setting.vue?vue&type=template&id=9f424cb2"
import script from "./Lottery_setting.vue?vue&type=script&lang=js"
export * from "./Lottery_setting.vue?vue&type=script&lang=js"
script.render = render

export default script